import { tOption, tSettingsFont, tTranslationResponse } from './types';

export const zSafeParse = (zodObject, dataToValidate) => {
  const result = zodObject.safeParse(dataToValidate);
  if (result.success === false) {
    // eslint-disable-next-line no-console
    console.error(
      Object.entries(result.error)
        .filter(([_, value]) => value !== '')
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {}),
    );
    return result;
  }
  return result.data;
};

export const createTranslationKeyQuery = (keyArray: string[]) =>
  keyArray
    .map((key, index) =>
      keyArray.length - 1 === index ? `keys=${key}` : `keys=${key}&`,
    )
    .join('');

export const formatTranslationKeyResponse = (
  response: tTranslationResponse,
) => {
  const fetchedLanguageKeys = {};
  response?.translations?.forEach((langKey) => {
    fetchedLanguageKeys[langKey.key] = langKey.value;
  });
  return fetchedLanguageKeys;
};

const style = (() => {
  const newStyle = document.createElement('style');
  newStyle.appendChild(document.createTextNode(''));
  document.head.appendChild(newStyle);
  return newStyle;
})();

export const setCustomFont = (fonts: tSettingsFont[]) => {
  const formats = ['.tff', '.woff', '.woff2', '.otf'];
  let fontFams = '';
  let fontUrls = '';
  fonts.forEach((font) => {
    fontFams = fontFams.concat(`${font.family}, `);
    if (font.url && formats.some((v) => font.url!.indexOf(v) >= 0)) {
      fontUrls = fontUrls.concat(`url("${font.url}"),`);
    } else if (font.url && style.sheet) {
      style.sheet.insertRule(`@import url(${font.url})`);
    }
  });
  if (style.sheet) {
    style.sheet.insertRule(
      `@font-face {
      font-family: "${fontFams.slice(0, -2)}";
      src: ${fontUrls.slice(0, -1)};}
      `,
      0,
    );
  }
  return fontFams.slice(0, -2);
};

export const getValueLabelFromStringArray = (data: string[]): tOption[] =>
  data.map((item) => ({
    value: item,
    label: item,
  }));

export const getValueLabelFromNumber = (data: number[]): tOption[] =>
  data.map((item) => ({
    value: item.toString(),
    label: item.toString(),
  }));

export const constructNumberArray = (q: number) =>
  Array.from({ length: q }, (_, i) => i + 1);

export const formatOrderNumbers = (numbers: string[], orderLines: boolean) => {
  let res = '';
  if (orderLines) {
    res = numbers
      .map((currentElement) => `&lineNumbers=${currentElement}`)
      .join('');
  } else {
    if (!numbers) {
      return undefined;
    }
    res = numbers
      .map(
        (currentElement, index) =>
          `&orderNumbers=${currentElement}${index !== numbers.length - 1 ? '&' : ''
          }`,
      )
      .join('');
  }
  return res;
};
